export class SaasContainerCapture {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "kind",
            "baseName": "kind",
            "type": "SaasContainerKind",
            "format": ""
        },
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "captureOutcome",
            "baseName": "captureOutcome",
            "type": "SaasCaptureOutcome",
            "format": ""
        },
        {
            "name": "captureReason",
            "baseName": "captureReason",
            "type": "SaasCaptureReason",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SaasContainerCapture.attributeTypeMap;
    }
    constructor() {
    }
}
